'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Star-module_container__IcMSs{height:auto;vertical-align:middle;width:2rem;fill:#000}";
var styles = {"container":"Star-module_container__IcMSs"};
styleInject["default"](css_248z, '1f767672-c4c2-4d92-8b92-2483276881d8');

exports["default"] = styles;
